import { config } from '@iheartjane/config';

/* eslint-disable-next-line no-restricted-imports */
import type { Identification } from '@jane/shared/models';

import { request } from '../lib/request';

export class IdentificationSource {
  static urlRoot = `${config.apiPath}/documents`;

  static get() {
    return request(this.urlRoot, {
      method: 'GET',
    });
  }

  static update(documentPart: { document: Partial<Identification> }) {
    return request(this.urlRoot, {
      method: 'PATCH',
      body: JSON.stringify(documentPart),
    });
  }
}
